import { Navigate } from "react-router-dom";
import { strings } from "../strings/strings";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const isAuthenticated = localStorage.getItem("ACCESS_TOKEN");
  const role = localStorage.getItem("role");

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(role)) {
    if (role === strings.super_admin) return <Navigate to="/superadmin/country-admin" replace />;
    if (role === strings.country_admin) return <Navigate to="/country" replace />;
  }

  return children;
};

export default ProtectedRoute;
